var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefinitionsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.816 1.183C22.095.46 21.1.043 20.015.003c-1.03-.04-2.085.25-3.04.836a.893.893 0 0 0-.298 1.23.893.893 0 0 0 1.228.298c1.299-.796 2.796-.761 3.642.085.498.497.727 1.218.642 2.03-.09.88-.522 1.746-1.219 2.442-.696.697-1.567 1.13-2.443 1.22-.81.079-1.532-.15-2.03-.642a1.713 1.713 0 0 0-2.413 0 1.693 1.693 0 0 0-.497 1.209c0 .457.18.885.503 1.209a1.713 1.713 0 0 0 2.602-.224c.472.169.98.258 1.517.258.164 0 .333-.01.502-.024.015 0 .03-.005.045-.005l.154 2.234a1.778 1.778 0 0 1-.512 1.368l-8.343 8.334a1.207 1.207 0 0 1-1.702 0L2.14 15.646a1.197 1.197 0 0 1 0-1.701l8.339-8.34a1.76 1.76 0 0 1 1.363-.512l7.408.493a.897.897 0 1 0 .12-1.791l-7.409-.493a3.536 3.536 0 0 0-2.746 1.035L.876 12.676A2.973 2.973 0 0 0 0 14.796c0 .8.313 1.552.876 2.119l6.209 6.21a3.003 3.003 0 0 0 4.239 0l8.338-8.34a3.558 3.558 0 0 0 1.035-2.756l-.18-2.617a6.32 6.32 0 0 0 1.727-1.224c.985-.985 1.602-2.239 1.731-3.527.134-1.359-.278-2.593-1.16-3.478z",
    fill: "#F8F8F8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefinitionsActive);
export default __webpack_public_path__ + "static/media/definitions-active.872b56c8360667465203520f2f0f092f.svg";
export { ForwardRef as ReactComponent };